export var IdMarketCategory;
(function (IdMarketCategory) {
    IdMarketCategory[IdMarketCategory["Improvement"] = 6] = "Improvement";
    IdMarketCategory[IdMarketCategory["Main"] = 22] = "Main";
    IdMarketCategory[IdMarketCategory["Adventure"] = 24] = "Adventure";
})(IdMarketCategory || (IdMarketCategory = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/market/IdMarketCategory.ts
// module id = 435
// module chunks = 3